// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="noPropertyHeader">Invalid Address</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="noPropertyParagraph1">Please confirm that the address you entered is correct.</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="confirm" class="Button Button--blue Button--minWidth130" (click)="closeThisDialog(0)">Confirm</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;